jQuery(document).ready(function ($) {
	APP.init();

	// init
	menuInit();
	lozadInit();
	fancyboxInit();
	accordionInit();
	toggleDropdown();
	formInit();

	jQuery('[data-toggle="tabslet"]').tabslet();
	jQuery('table').each(function () {
		jQuery(this).wrap('<div class="table-scroll"></div>');
	});
});

jQuery(window).on('scroll', function () {
	APP.fixed();
	if (jQuery('.box-summary').length) {
		jQuery(window).scrollTop() > (jQuery('.box-summary').offset().top - heightHeader) ? jQuery('.button-sticky').addClass('active') : jQuery('.button-sticky').removeClass('active');
	}
});

// variable
var header = jQuery("header"),
	backToTop = jQuery(".back-to-top"),
	backdrop = jQuery(".backdrop"),
	heightHeader = jQuery("header").height(),
	heightWindow = jQuery(window).height(),
	widthWindow = jQuery(window).width(),
	mobileWrap = jQuery(".header-mobile-wrap"),
	searchWrap = jQuery(".header-search-mobile-wrap"),
	outerHeightWindow = jQuery(window).outerHeight();

// toggleText
jQuery.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

var APP = {
	fixed: () => {
		// header
		jQuery(window).scrollTop() > heightHeader
			? header.addClass("active")
			: header.removeClass("active");
		jQuery(window).scrollTop() > (outerHeightWindow - heightHeader)
			? backToTop.addClass("active")
			: backToTop.removeClass("active");
	},
	backdrop: () => {
		backdrop.on('click', function () {
			jQuery(this).removeClass('show');
			header.removeClass("open"); // remove header
			jQuery("#buttonMenu").removeClass('open'); // remove button menu header
			mobileWrap.removeClass('open'); // remove menu header
			searchWrap.removeClass("open"); // remove search header
		})
	},
	backToTop: () => {
		backToTop.on('click', function () {
			jQuery('html, body').animate({ scrollTop: 0 }, 500);
		})
	},
	mapping: () => {
		let mainMenu = jQuery("header .navbar-nav").mapping({
			mobileWrapper: ".header-mobile-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-wrap-right",
			desktopMethod: "prependTo",
			breakpoint: 1279.98,
		});
		let searchBox = jQuery("header .search-wrap").mapping({
			mobileWrapper: ".header-search-mobile-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: "header .language",
			desktopMethod: "insertBefore",
			breakpoint: 767.98,
		});
		let social = jQuery("header .social-list").mapping({
			mobileWrapper: ".header-mobile-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-top-right",
			desktopMethod: "appendTo",
			breakpoint: 767.98,
		});
	},
	toggleMenu: () => {
		jQuery("#buttonMenu").on("click", function () {
			jQuery(this).toggleClass("open");
			mobileWrap.toggleClass("open");
			backdrop.toggleClass("show");
			searchWrap.removeClass("open");
		});
	},
	toggleSearch: () => {
		jQuery(".button-search").on("click", function () {
			jQuery(this).toggleClass("open");
			searchWrap.toggleClass("open");
			backdrop.toggleClass("show");
			mobileWrap.removeClass("open");
		});
	},
	sourceInfo: () => {
		console.log(
			"%cGMGA",
			"font-size:100px;color:#F5A01C;text-shadow:0 1px 0 #f2c94c,0 2px 0 #f2c94c ,0 3px 0 #f2c94c ,0 4px 0 #f2c94c ,0 5px 0 #f2c94c ,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);"
		);
		console.log(
			"%c GMGA %c - GMGA in Viet Nam",
			"border-radius: 2px; padding: 3px; background: #0F9647; color: #ffffff",
			"color: #0F9647"
		);
	},
	init: () => {
		APP.backdrop();
		APP.backToTop();
		APP.mapping();
		APP.toggleMenu();
		APP.toggleSearch();
		APP.sourceInfo();
	}
}

// swiper
const homeBannerThumbsSlider = new Swiper(".home-banner .swiper-thumbs", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 30,
	navigation: {
		prevEl: ".home-banner .button-prev",
		nextEl: ".home-banner .button-next",
	},
	pagination: {
		el: ".home-banner .swiper-pagination",
		clickable: true,
	}
});

const configBannerGL = widthWindow >= 1280 ? ({
	modules: [SwiperGL],
	effect: 'gl',
	gl: {
		shader: 'random',
	},
	shuttersEffect: {
		split: 5,
	},
}) : ({});

const homeBannerTopSlider = new Swiper(".home-banner .swiper-top", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	...configBannerGL,
});

homeBannerTopSlider.controller.control = homeBannerThumbsSlider;
homeBannerThumbsSlider.controller.control = homeBannerTopSlider;

// home about
const homeAboutSlider = new Swiper(".home-about .swiper", {
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 30,
	navigation: {
		prevEl: ".home-about .button-prev",
		nextEl: ".home-about .button-next",
	},
	pagination: {
		el: ".home-about .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 3,
		},
		1024: {
			slidesPerView: 4,
		},
	}
});

// home brand
const homeBrandsSlider = new Swiper(".home-brands .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	slidesPerView: 2,
	spaceBetween: 10,
	navigation: {
		prevEl: ".home-brands .button-prev",
		nextEl: ".home-brands .button-next",
	},
	pagination: {
		el: ".home-brands .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 5,
			spaceBetween: 30,
		},
	}
});

// recruitment
const recruitmentSlider = new Swiper(".recruitment-section .swiper", {
	speed: 1000,
	slidesPerView: 1,
	grid: {
		rows: 5,
	},
	spaceBetween: 20,
	navigation: {
		prevEl: ".recruitment-section .button-prev",
		nextEl: ".recruitment-section .button-next",
	},
	pagination: {
		el: ".recruitment-section .swiper-pagination",
		clickable: true,
	},
});
const recruitmentDetailSlider = new Swiper(".recruitment-detail .swiper", {
	speed: 1000,
	slidesPerView: 1,
	grid: {
		rows: 5,
	},
	spaceBetween: 20,
	navigation: {
		prevEl: ".recruitment-detail .button-prev",
		nextEl: ".recruitment-detail .button-next",
	},
	pagination: {
		el: ".recruitment-detail .swiper-pagination",
		clickable: true,
	},
});
// home products group
jQuery('.home-products').each(function (index) {
	// swiper tabslet tabs
	jQuery(this).find('.tabslet-tabs .swiper').addClass(`swiper-tabs-${index}`);
	jQuery(this).find('.tabslet-tabs .button-prev').addClass(`button-prev-tabs-${index}`);
	jQuery(this).find('.tabslet-tabs .button-next').addClass(`button-next-tabs-${index}`);
	// swiper tabslet products
	jQuery(this).find('.swiper-home-product .swiper').addClass(`swiper-product-${index}`);
	jQuery(this).find('.swiper-home-product .swiper-pagination').addClass(`swiper-pagination-product-${index}`);
	jQuery(this).find('.swiper-home-product .button-prev').addClass(`button-prev-product-${index}`);
	jQuery(this).find('.swiper-home-product .button-next').addClass(`button-next-product-${index}`);
	const homeProductTabsSlider = new Swiper(`.home-products .swiper-tabs-${index}`, {
		slidesPerView: "auto",
		spaceBetween: 0,
		navigation: {
			prevEl: `.home-products .button-prev-tabs-${index}`,
			nextEl: `.home-products .button-next-tabs-${index}`,
		},
	});

	const homeProductSlider = new Swiper(`.home-products .swiper-product-${index}`, {
		// loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 1000,
		rewind: true,
		slidesPerView: 2,
		spaceBetween: 10,
		navigation: {
			prevEl: `.home-products .button-prev-product-${index}`,
			nextEl: `.home-products .button-next-product-${index}`,
		},
		pagination: {
			el: `.home-products .swiper-pagination-product-${index}`,
			clickable: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 15,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
		}
	});
});

// home partners
const homePartnersSlider = new Swiper(".home-partners .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	slidesPerView: 2,
	spaceBetween: 10,
	navigation: {
		prevEl: ".home-partners .button-prev",
		nextEl: ".home-partners .button-next",
	},
	pagination: {
		el: ".home-partners .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 5,
			spaceBetween: 30,
		},
	}
});

// home news
const homeNewsSlider = new Swiper(".home-news .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 10,
	navigation: {
		prevEl: ".home-news .button-prev",
		nextEl: ".home-news .button-next",
	},
	pagination: {
		el: ".home-news .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	}
});

const productDetailThumbsSlider = new Swiper(".product-detail-slider .swiper-thumbs", {
	slidesPerView: 4,
	spaceBetween: 10,
	watchSlidesProgress: true,
	breakpoints: {
		768: {
			direction: "vertical",
			slidesPerView: 5,
			spaceBetween: 15,
		},
		1024: {
			direction: "vertical",
			slidesPerView: 5,
			spaceBetween: 15,
		},
		1280: {
			direction: "vertical",
			slidesPerView: 5,
			spaceBetween: 15,
		},
	},
});

const productDetailTopSlider = new Swiper(".product-detail-slider .swiper-top", {
	spaceBetween: 30,
	thumbs: {
		swiper: productDetailThumbsSlider,
	},
	navigation: {
		nextEl: ".product-detail-slider .button-next",
		prevEl: ".product-detail-slider .button-prev",
	},
});

// home news
const newsOtherSlider = new Swiper(".news-other .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 10,
	navigation: {
		prevEl: ".news-other .button-prev",
		nextEl: ".news-other .button-next",
	},
	pagination: {
		el: ".news-other .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	}
});
// end swiper

function lozadInit() {
	// Initialize library to lazy load images
	const observer = lozad('.lozad', {
		threshold: 0.1,
		// enableAutoReload: true,
	})

	// Picture observer
	// with default `load` method
	const pictureObserver = lozad('.lozad-picture', {
		threshold: 0.1
	})

	// Background observer
	// with default `load` method
	const backgroundObserver = lozad('.lozad-background', {
		threshold: 0.1
	})

	observer.observe()
	pictureObserver.observe()
	backgroundObserver.observe()
}

function fancyboxInit() {
	Fancybox.bind("[data-fancybox]", {
		showLoading: true,
		preload: true,
		infinite: false,
		// parentEl: document.forms[0], // Element containing main structure
		mainClass: "fancybox-wrapper", // Custom class name or multiple space-separated class names for the container
	});

	Fancybox.bind("a.popup-link", {
		showLoading: true,
		type: "iframe",
		preload: true,
	});

	Fancybox.bind('[data-fancybox="single"]', {
		groupAttr: false,
	});

	jQuery(".btn-close-fancybox").on("click", function () {
		Fancybox.close();
	});
}

function equalHeight(el) {
	var height = 0;
	jQuery(el).each(function () {
		var thisHeight = jQuery(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			jQuery(el).height(height)
		}, 100)
	})
}

function accordionInit() {
	jQuery('.accordion-item').on('click', function () {
		jQuery(this)
			.toggleClass('active')
			.siblings().removeClass('active')
		jQuery(this)
			.find('.accordion-header').toggleClass('active')
			.parents('.accordion-item')
			.siblings().find('.accordion-header').removeClass('active')
		jQuery(this)
			.find('.accordion-content').slideToggle()
			.parents('.accordion-item')
			.siblings().find('.accordion-content').slideUp('active')
	});
}

function menuInit() {
	// append icon to menu
	jQuery('.menu-item-has-children, .product-categories .cat-item.cat-parent').append('<span class="menu-item-icon"><i class="fa-light fa-chevron-down"></i></span>');

	// toggle menu
	jQuery('.menu-item-has-children > .menu-item-icon, .product-categories .cat-item.cat-parent > .menu-item-icon').on('click', function () {
		jQuery(this).toggleClass('active').parent().find('> .sub-menu, > .children').slideToggle();
		jQuery(this).parent().siblings().find('> .sub-menu, > .children').slideUp();
	});

	// show menu active
	jQuery('.menu-item-has-children.active, .product-categories .cat-item.cat-parent.active, .product-categories .cat-item.current-cat-parent, .product-categories .cat-item.current-cat, .current-category-ancestor').each(function () {
		jQuery(this).find('> .sub-menu, > .children').slideDown();
		jQuery(this).find('> .menu-item-icon').addClass('active');
	});
}

function toggleDropdown() {
	jQuery('.select-dropdown .select-current').on('click', function () {
		jQuery(this).next().slideToggle();
	});
	jQuery('.box-sticky .sticky-title').on('click', function () {
		if (widthWindow < 768) {
			jQuery(this).toggleClass('active').next().slideToggle();
		}
	});

	jQuery('.product-detail .full-content').each(function (index) {
		if (jQuery(this).height() < 800) {
			jQuery(this).find('.view-full-content').addClass('hidden')
		} else {
			jQuery(this).addClass('max-height');
		}
		jQuery(this).find('.view-full-content > a').on('click', function (e) {
			e.preventDefault();
			jQuery(this).parent().toggleClass('active').parent().toggleClass('active');
		});
	});
}

function formInit() {
	if (jQuery('#fileCv')) {
		jQuery('#fileCv').change(function () {
			jQuery('#uploadName').text(this.files[0].name);
		});
	}
}
